export const SLIDY_30 = 'slidy30';
export const SLIDY_36 = 'slidy36';
export const ALU_GLAZY = 'aluglazy';
export const WOODY_ELEMENTS = 'woodyelements';
export const WOODY_PLANE = 'woodyplane';
export const WOODY_GLAZY = 'woodyglazy';
export const WOODY_ALU = 'woodyalu';
export const ALU_2K_GLAZY = 'alu2kglazy';
export const WOODY_2K_ALU = 'woody2kalu';
export const WOODY_2K_GLAZY = 'woody2kglazy';
export const WOODY_2K_ELEMENTS = 'woody2kelements';
export const GLAZY_DOUBLE = 'glazydouble';
export const SHOP = 'shop';
export const TWO_K_TYPE = '2K';

const glazingWallTypes = [
  SLIDY_30,
  SLIDY_36,
  ALU_GLAZY,
  WOODY_ELEMENTS,
  WOODY_PLANE,
  WOODY_GLAZY,
  WOODY_ALU,
  ALU_2K_GLAZY,
  WOODY_2K_ALU,
  WOODY_2K_GLAZY,
  WOODY_2K_ELEMENTS,
  GLAZY_DOUBLE,
  SHOP,
  TWO_K_TYPE,
];

export default glazingWallTypes;
